import { useEffect } from "react";
import { useRedirectOnInit } from "../lib/client/hooks/useRedirectOnInit";
import { useShallow } from "zustand/react/shallow";
import { useLauncherStore } from "../lib/client/contexts/LauncherStoreContext";

export default function InitLocale({
  params,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string };
}) {
  const redirect = useRedirectOnInit(params);
  const { isOpen, showLauncherButton, config, isInitialized } = useLauncherStore(
    useShallow((state) => ({
      isInitialized: state.isInitialized,
      isOpen: state.isOpen,
      showLauncherButton: state.showLauncherButton,
      config: state.config,
    })),
  );

  useEffect(() => {
    // Wait until LaunchContext > init() has run before redirecting
    if (!isInitialized) return;
    // If no launcher button is shown, we don't want to redirect until open is true
    if (!isOpen && !showLauncherButton) return;
    if (!config) return;

    redirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, isOpen, showLauncherButton, config]);

  return null;
}
